import Login from '@modules/account/components/login';

const LoginTemplate = () => {
  return (
    <div className="flex w-full flex-col items-center justify-center py-6 lg:px-8">
      <h1 className="border-primary-60 text-primary-60 mb-16 border-b-2 px-3 py-3 text-lg font-bold lg:w-[131px] lg:text-2xl">
        會員登入
      </h1>
      <div className="w-full lg:w-[644px]">
        <Login />
      </div>
    </div>
  );
};

export default LoginTemplate;
